module.exports = __webpack_public_path__ + "static/media/yellow.3f5da388.png";